<rid-demo-page [title]="'Oefenvormen'" previousRoute="/">
  <rid-button class="w-full" content="Klankbord" variant="PRIMARY" [disabled]="true" />
  <rid-button class="w-full" content="Lezen: basis" variant="PRIMARY" routerLink="reading-basis" />
  <rid-button class="w-full" content="Lezen: matrix" variant="PRIMARY" routerLink="reading-matrix" />
  <rid-button class="w-full" content="Lezen: expressie" variant="PRIMARY" [disabled]="true" />
  <rid-button class="w-full" content="Fonologisch bewustzijn" variant="PRIMARY" routerLink="phonetic-comprehension" />
  <rid-button class="w-full" content="Sorteren" variant="PRIMARY" routerLink="sorting" />
  <rid-button class="w-full" content="Morfemen" variant="PRIMARY" [disabled]="true" />
  <rid-button class="w-full" content="Dictee" variant="PRIMARY" routerLink="dictation" />
  <rid-button class="w-full" content="Games" variant="PRIMARY" [disabled]="true" />
</rid-demo-page>
